import { Component, Event, EventEmitter, h, Host, Listen, Element } from '@stencil/core';
import { TiMetricsActionEventDetail } from '@ticom/web-component-utils';

@Component({
    tag: 'ti-breadcrumb',
    styleUrl: 'breadcrumb.scss',
    shadow: true
})
export class Breadcrumb {

    @Element() hostElement: HTMLTiBreadcrumbElement;

    /**
     * Event for when a metrics actions occurs.
     */
    @Event() tiMetricsAction: EventEmitter<TiMetricsActionEventDetail>;

    componentDidLoad() {
        // apply z-index to breadcrumb section elements - decreasing to min 150
        const sections = this.hostElement.querySelectorAll('ti-breadcrumb-section');
        let zIndex = 150 + sections.length - 1;
        sections.forEach((sectionElement) => {
            sectionElement.style.zIndex = `${zIndex--}`;
        });
    }

    /**
     * listen to the tiBreadcrumbHover
     * and emit tiMetricsAction event
     */
    @Listen('tiBreadcrumbHover')
    onTiBreadcrumbHover(event) {
        const eventName = 'hover';
        const elementName = 'breadcrumb';
        const data = {
            context: event.detail //event.detail returns the breadcrumb label
        };
        this.tiMetricsAction.emit({
            eventName: eventName,
            elementName: elementName,
            data: data
        });
    }

    render() {
        return (
            <Host>
                <slot />
            </Host>
        );
    }
}
